import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Children } from 'react';
// -*- mode: jsx;-*-
import { KeyboardClickable } from './KeyboardClickable.js';
import { Svg } from './Svg.js';
import { SHARE_TOOLS, trackShareToolClick } from './shareToolUtils.js';

/* global dcAnalytics */

export const safeNextdoorURL = (body, link) => {
    // Add spaces so Nextdoor doesn't assume they are framing a url :eyeroll:
    body = body.replace(/(\S+)\.(\S+)/g, '$1. $2');
    return `https://nextdoor.com/sharekit/?source=DonorsChoose&hashtag=fundraising&body=${encodeURIComponent(body)}` + link;
};

export const NextdoorLink = createReactClass({
    propTypes: {
        urlToShare: PropTypes.string.isRequired,
        pageName: PropTypes.string,
        getTrackingLink: PropTypes.func.isRequired,
        useSpan: PropTypes.bool,
        className: PropTypes.string,
        closeAfterShare: PropTypes.bool,
        onNextdoorClick: PropTypes.func.isRequired,
        children: PropTypes.node,
        teacherName: PropTypes.string.isRequired,
        schoolName: PropTypes.string.isRequired,
        projectSummary: PropTypes.string.isRequired,
        projectId: PropTypes.number,
        essentialsListShare: PropTypes.bool,
    },

    getDefaultProps: function () {
        return {
            closeAfterShare: false,
        };
    },

    getNextdoorUrl: function () {
        const teacherName = this.props.teacherName;
        const teacherSchool = this.props.schoolName;
        const intro = `Hi! I'm ${teacherName}, a teacher at ${teacherSchool} and a neighbor here.`;
        const summary = this.props.projectSummary;
        const outro = 'Support my students here: ';
        const body = `${intro}\n\n${summary}\n\n${outro}`
            // Add spaces so Nextdoor doesn't assume they are framing a url :eyeroll:
            .replace(/(\S+)\.(\S+)/g, '$1. $2');
        const paramLinks = this.props.getTrackingLink(this.props.urlToShare, 'nextdoor', this.props.pageName);
        return safeNextdoorURL(body, paramLinks);
    },

    shareIcon: function () {
        if (Children.count(this.props.children) > 0) {
            return null;
        } else {
            return (
                <Svg icon="ss-nextdoor" iconFamily="social-circle"/>
            );
        }
    },

    onClick(event) {
        dcAnalytics.trackShareToolClick(this.props.pageName, this.props.urlToShare, 'Nextdoor', this.props.essentialsListShare);
        trackShareToolClick(this.props.projectId, SHARE_TOOLS.NEXTDOOR);
        return this.props.onNextdoorClick(event, this.getNextdoorUrl());
    },

    render: function () {
        if (this.props.useSpan) {
            return (
                <KeyboardClickable>
                    <span tabIndex="0"
                        onClick={this.onClick}
                        aria-label="Share on Nextdoor"
                        className={this.props.className + ' heap-nextdoor-share'}>
                        {this.shareIcon()}
                        {this.props.children}
                    </span>
                </KeyboardClickable>
            );
        } else {
            return (
                <a href={this.getNextdoorUrl()}
                    onClick={this.onClick}
                    target="_blank"
                    aria-label="Share on Nextdoor"
                    className={this.props.className + ' heap-nextdoor-share'} rel="noreferrer">
                    {this.shareIcon()}
                    {this.props.children}
                </a>
            );
        }
    },
});
